import service from "@/store/services/pos-products-report-service";

export const state = () => ({
  reportData: [],
  meta: {},
  loading: false,
});

export const mutations = {
  SET_REPORT_DATA: (state, data) => {
    state.reportData = data;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_LOADING: (state, loading) => {
    state.loading = loading;
  },
};

export const actions = {
  fetchReport({ commit }, params) {
    commit("SET_LOADING", true);
    return service
      .getReport(params)
      .then(({ data, meta }) => {
        commit("SET_REPORT_DATA", data);
        commit("SET_META", meta);
        return { data, meta };
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
};

const getters = {
  reportData: (state) => state.reportData,
  meta: (state) => state.meta,
  loading: (state) => state.loading,
  totalPages: (state) =>
    state.meta?.page?.last_page || Math.ceil((state.meta?.page?.total || 0) / (state.meta?.page?.per_page || 25)),
};

const posProductsReport = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default posProductsReport;
